/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject } from "rxjs";
import { API_PATH, isJDXHomePage } from "src/environments/config";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { StoresService } from "../../catalog/stores.service";
import { LiveshopService } from "../../liveshop/liveshop.service";
import { SlotService } from "../../slot/slot.service";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  public islocalStorageUpdated = new BehaviorSubject(false);
  public isLogoUpdated = new BehaviorSubject([]);
  public activateRingtone = new BehaviorSubject(false);
  public playRingtone = new BehaviorSubject(false);
  isRingtoneActivated = false;
  public islocalStorageChannelsUpdated = new BehaviorSubject(false);
  public companyConfig;
  isJDXHomePage = isJDXHomePage;
  public currentTab;
  public unitChangeCount = 0;
  public usersPageCount = 0;
  public branchesCallCount = 0;
  public divisionCallCount = 0;
  public divisionCreationCount = 0;
  public boardingUsersCount = 0;
  public isLoaderDisabled = false;
  public isRetailerVersion = false;
  isMobileUpdate = false;
  constructor(
    private http: HttpClient,
    public slotService: SlotService,
    public storesService: StoresService,
    public userService: UserService,
    private router: Router,
    private toastrService: ToastrService,
    private liveshopService: LiveshopService
  ) {}
  setUserData(data, bunit?) {
    if (data.user && data.user.type === "B2C" && data.token) {
      localStorage.setItem("userPic", data.user.profileImageURL);
      localStorage.setItem("user", JSON.stringify(data.user ? data.user : "-"));
      localStorage.setItem("nVipaniwhiteshopkey", data.token);
      localStorage.setItem("nVipaniwhiteshopUser", data.user.username);
    } else if (data.user) {
      localStorage.setItem(
        "businessUnits",
        JSON.stringify(
          data.businessUnits.businessUnits
            ? data.businessUnits.businessUnits
            : "-"
        )
      );
      localStorage.setItem(
        "company",
        JSON.stringify(data.company ? data.company : "-")
      );
      localStorage.setItem("user", JSON.stringify(data.user ? data.user : "-"));
      localStorage.setItem(
        "userGroup",
        JSON.stringify(
          data.businessUnits.userGroup ? data.businessUnits.userGroup : "-"
        )
      );
      localStorage.setItem("retailerToken", data.token ? data.token : "-");
      if (bunit) {
        this.setCurrentBusinessUnit(
          data.businessUnits.businessUnits[0].businessUnit
        );
      }
    }
  }
  setCurrentBusinessUnit(bunit) {
    localStorage.setItem("currentBusinessUnitId", bunit.toString());
  }
  resetUserData() {
    const virtualStoreInstructions = localStorage.getItem(
      "virtualStoreInstructions"
    )
      ? true
      : false;
    localStorage.clear();
    if (virtualStoreInstructions)
      localStorage.setItem("virtualStoreInstructions", "true");
  }

  updateBusinessUnits(action, data) {
    switch (action) {
      case "add": {
        const businessUnits = JSON.parse(localStorage.getItem("businessUnits"));
        const businessUnit = {
          name: data.name,
          _id: data._id,
          images:
            data.gallery.images && data.gallery.images.length
              ? data.gallery.images[0]
              : "",
          settings: data.settings,
          currency: data.currency,
        };

        if (data.addresses && data.addresses[0]) {
          businessUnit["address"] = data.addresses[0];
        } else {
          businessUnit["address"] = "";
        }
        businessUnits.push({
          businessUnit: businessUnit,
          defaultBusinessUnit: false,
        });
        localStorage.setItem(
          "businessUnits",
          JSON.stringify(businessUnits ? businessUnits : "-")
        );
        break;
      }
      case "edit": {
        const businessUnits = JSON.parse(localStorage.getItem("businessUnits"));
        const index = businessUnits.findIndex(
          (eachBusinessUnit) => eachBusinessUnit.businessUnit._id === data._id
        );
        const currentUnit = JSON.parse(
          sessionStorage.getItem("currentBusinessUnit")
        );
        const currentIndex = businessUnits.findIndex(
          (eachBusinessUnit) =>
            eachBusinessUnit.businessUnit._id === currentUnit._id
        );
        if (index !== -1) {
          businessUnits[index].businessUnit["name"] = data.name;
          businessUnits[index].businessUnit["_id"] = data._id;
          businessUnits[index].businessUnit["images"] =
            data.gallery.images && data.gallery.images.length
              ? data.gallery.images[0]
              : "";
          businessUnits[index].businessUnit["settings"] = data.settings;
          businessUnits[index].businessUnit["currency"] = data.currency;
          if (data.addresses && data.addresses[0]) {
            businessUnits[index].businessUnit["address"] = data.addresses[0];
          } else {
            businessUnits[index].businessUnit["address"] = "";
          }
          if (data.brandImage && data.brandImage.length) {
            businessUnits[index].businessUnit["brandImage"] = data.brandImage;
          }
          if (index === currentIndex) {
            sessionStorage.setItem(
              "currentBusinessUnit",
              JSON.stringify(businessUnits[index].businessUnit)
            );
          }
        }
        localStorage.setItem(
          "businessUnits",
          JSON.stringify(businessUnits ? businessUnits : "-")
        );
        break;
      }
    }
    this.islocalStorageUpdated.next(true);
  }

  isUserGroupValid(userType) {
    const userGroupObject = JSON.parse(localStorage.getItem("userGroup"));
    return userGroupObject && userGroupObject.name === userType;
  }

  getCompanyConfig(code?, configId?, linkCode?, companyId?) {
    return this.http.get<any>(
      API_PATH.apis.configurationURL +
        (code ? "?code=" + code : "") +
        (configId ? "?configId=" + configId : "") +
        (linkCode ? "?linkCode=" + linkCode : "") +
        (companyId ? "?companyId=" + companyId : "")
    );
  }

  updateCompanyConfig(data) {
    if (data.companyConfigVersionKey) {
      delete data.companyConfigVersionKey;
    }
    return this.http.put<any>(API_PATH.apis.configurationURL, data);
  }
  c2cKeyGen() {
    return this.http.get<any>(API_PATH.apis.clickToCallKeyGen);
  }
  postLoginActions(res, isScheduledAppointment?) {
    if (
      res.businessUnits &&
      res.businessUnits.businessUnits &&
      res.businessUnits.businessUnits.length
    ) {
      const index = res.businessUnits.businessUnits.findIndex(
        (eachBu) => eachBu.defaultBusinessUnit
      );
      if (index !== -1) {
        this.slotService.currentBusinessUnit =
          res.businessUnits.businessUnits[index].businessUnit;
      } else {
        this.slotService.currentBusinessUnit =
          res.businessUnits.businessUnits[0].businessUnit;
      }

      this.userService.selectedBusinessUnitData = this.slotService.currentBusinessUnit;
      this.userService.currentBusinessUnitDetailBS.next(
        this.slotService.currentBusinessUnit
      );

      sessionStorage.setItem(
        "currentBusinessUnit",
        JSON.stringify(this.slotService.currentBusinessUnit)
      );
      this.slotService.setCurrencyObject();
      this.getCompanyConfig().subscribe((res) => {
        console.log(res);
        if (!(res.channels && res.channels.facebookUrl)) {
          res["channels"] = {
            facebookUrl: "",
            twitterUrl: "",
            instagramUrl: "",
            linkedinUrl: "",
            youtubeUrl: "",
          };
        }
        localStorage.setItem("companyConfig", JSON.stringify(res));
        localStorage.setItem("config", JSON.stringify(res));
        if (
          !JSON.parse(localStorage.getItem("user")).type &&
          !isScheduledAppointment
        ) {
          if (
            JSON.parse(localStorage.getItem("userGroup")).name === "Employee" &&
            JSON.parse(localStorage.getItem("companyConfig")).whiteshop
              .isClickToCall
          ) {
            this.router.navigateByUrl("/my-company");
          } else {
            this.router.navigateByUrl("/homePage");
          }
        }
        this.islocalStorageChannelsUpdated.next(true);
      });
    }
  }
  getConfig() {
    if (isJDXHomePage.flag) {
      if (!localStorage.getItem("config")) {
        const code = window.location.hostname.includes(
          "highlineunitedmarketplace"
        )
          ? "HIGHLINE"
          : window.location.hostname.includes("patrician")
          ? "PATRICIANASH"
          : "";
        // if (code && code.length) {
        this.getCompanyConfig(code).subscribe(
          (res) => {
            localStorage.setItem("config", JSON.stringify(res));
            localStorage.setItem("companyConfig", JSON.stringify(res));
            this.islocalStorageChannelsUpdated.next(true);
          },
          (err) => {
            this.islocalStorageChannelsUpdated.next(true);
          }
        );
        // }
      }
    } else {
      let code;

      if (window.location.hostname.includes("kilburn")) {
        code = "KILBURN";
      }
      // if (code && code.length) {
      this.getCompanyConfig(code).subscribe(
        (res) => {
          localStorage.setItem("config", JSON.stringify(res));
          localStorage.setItem("companyConfig", JSON.stringify(res));
          localStorage.setItem(
            "isLanguageTranslation",
            res["whiteshop"].isLanguageTranslation
          );
          this.islocalStorageChannelsUpdated.next(true);
        },
        (err) => {
          this.islocalStorageChannelsUpdated.next(true);
        }
      );
      // }
      this.islocalStorageChannelsUpdated.next(true);
    }
  }

  changeBusinessUnit(event, selectedBusinessUnit) {
    if (event !== selectedBusinessUnit) {
      this.slotService.currentBusinessUnit = event;
      sessionStorage.setItem(
        "currentBusinessUnit",
        JSON.stringify(this.slotService.currentBusinessUnit)
      );
    }
    this.slotService.setCurrencyObject();
    localStorage.setItem("selectedBusinessUnitId", event._id);
    const res = JSON.parse(localStorage.getItem("businessUnits")).find(
      (ele) => ele.businessUnit._id === event._id
    ).businessUnit;
    res["currentTab"] = this.currentTab;
    this.userService.selectedBusinessUnitData = res;
    this.userService.currentBusinessUnitDetailBS.next(res);
    this.storesService.resetData();
    this.storesService.resetFiltersData();
  }

  resetCallData() {
    this.currentTab = "Users";
    this.unitChangeCount = 0;
    this.branchesCallCount = 0;
    this.boardingUsersCount = 0;
    this.divisionCreationCount = 0;
  }

  logout() {
    const currentBusinessUnit = sessionStorage.getItem("currentBusinessUnit");
    this.resetUserData();
    // sessionStorage.setItem("currentBusinessUnit", currentBusinessUnit);
    this.toastrService.success("Logout successful", null, { timeOut: 2000 });
    this.liveshopService.currentUser = undefined;
    location.reload();
    sessionStorage.clear();
  }
}
